<template>
  <div :class="{ 'my-4': !isReadOnly }">
    <div v-if="!isReadOnly" class="row pl-4">
      <div class="col-md-10">
        <validation-observer ref="observer" novalidate>
          <div class="row">
            <div v-if="showIntervation" class="col-12 col-md-6">
              <div class="data-name">
                Intervención:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-model="model.intervention"
                  custom-error-msg="Favor de seleccionar la interveción recomendada. (0023)"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.interventions"
                  placeholder="Seleccione"
                  @input="onChangeIntervention"
                />
              </validation-provider>
            </div>
            <div v-if="showFrequency" class="col-12 col-md-6">
              <div class="data-name">
                Frecuencia:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-model="model.frecuency"
                  custom-error-msg="Favor de seleccionar la frecuencia recomendada. (0208)"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.frequencies"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div v-if="showModalities" class="col-12 col-md-6 my-3">
              <div class="data-name">Modalidad:</div>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-drop-down
                  v-model="model.modality"
                  custom-error-msg="Favor de seleccionar la modalidad recomendada. (0210)"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="catalog.modalities"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div v-if="showDurations" class="col-12 col-md-6 my-3">
              <div class="data-name">Duración:</div>
              <validation-provider
                v-if="canShowDuration"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="model.duration"
                  custom-error-msg="Favor de seleccionar la duración recomendada. (0207)"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="durationsOptions"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
          </div>
        </validation-observer>
      </div>
      <div class="col-md-2 d-flex align-items-end justify-content-end">
        <action-button
          i="fa fa-file-plus"
          variant="success"
          @click="addServiceHandler"
        >
          Añadir
        </action-button>
      </div>
    </div>
    <div
      v-if="interventions.length"
      class="mx-3"
      :class="{ 'mt-5': !isReadOnly }"
    >
      <div
        v-for="(item, index) in interventions"
        :key="`intevention-${index}`"
        class="row bg-secondary-3 p-3 mb-3"
      >
        <div v-if="showIntervation" class="col">
          <div class="data-name">
            Tipo de Servicio:
          </div>
          <div>
            {{ item.analysisServiceDescription }}
          </div>
        </div>
        <div v-if="showModalities" class="col">
          <div class="data-name">
            Modalidad:
          </div>
          <div>
            {{ item.analysisServiceModalityDescription }}
          </div>
        </div>
        <div v-if="showFrequency" class="col">
          <div class="data-name">
            Frecuencia:
          </div>
          <div>
            {{ item.frequencyDescription }}
          </div>
        </div>
        <div v-if="showDurations" class="col">
          <div class="data-name">
            Duración:
          </div>
          <div>
            {{ item.durationDescription }}
          </div>
        </div>
        <div
          v-if="!isReadOnly"
          class="
            col
            text-right
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <action-button
            i="fa fa-times-circle"
            variant="outline-danger"
            @click="deleteServiceHandler(index)"
          >
            Eliminar
          </action-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

//components
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';

//utils
import DisciplineTypes from '@/utils/constants/disciplineTypeCode.js';
import Duration from '../utils/duration.js';

export default {
  name: 'InterventionRecomendation',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    getFrequencyType: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getServiceModalities: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getTherapyDurations: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getAppointmentTherpies: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getServices: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    showIntervation: {
      type: Boolean,
      default: () => true,
    },
    showFrequency: {
      type: Boolean,
      default: () => true,
    },
    showModalities: {
      type: Boolean,
      default: () => true,
    },
    showDurations: {
      type: Boolean,
      default: () => true,
    },
    //Catalog
    frequencies: {
      type: Array,
      default: () => [],
    },
    modalities: {
      type: Array,
      default: () => [],
    },
    durations: {
      type: Array,
      default: () => [],
    },
    catalogInterventions: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    appointmentTherapyFlag: null,
    model: {
      intervention: null,
      frecuency: null,
      modality: null,
      duration: null,
    },
    interventions: [],
    canShowDuration: true, // JSF: this is a force to reload the dropdown and show the content.
    durationsOptions: [], // JSF: this component does not update the computed properties until the user change the duration dropdown.
    // this component is kind of broken... so lets use durationsOptions to manually populate the data to show in the dropdown
  }),
  computed: {
    catalog() {
      return {
        interventions: this.catalogInterventions,
        frequencies: this.frequencies,
        modalities: this.modalities,
        durations: [], // JSF: it is not currently using.. in the next US we will use this instead of the forced one.
      };
    },
    durationCodes() {
      // JSF US105142 - ABA should show the following minutes
      if (this.isABASelected) {
        return [
          Duration._60Minutos,
          Duration._90Minutos,
          Duration._120Minutos,
          Duration._150Minutos,
          Duration._180Minutos,
          Duration._MasDe180Minutos,
        ];
      }
      return [Duration._30Minutos, Duration._45Minutos, Duration._60Minutos];
    },
    isABASelected() {
      return this.model.intervention?.id === DisciplineTypes.ABA;
    },
  },
  watch: {
    durations() {
      this.updateDurationOptions();
    },
  },
  async mounted() {
    await this.get();
  },
  methods: {
    updateDurationOptions() {
      this.durationsOptions = this.durations.filter(
        (x) => this.durationCodes.indexOf(x.id) !== -1
      );

      // if user selected a duration from ABA and then select other intervention where that duration
      // is not valid for that intervention, it resets the duration's dropdown.
      const hasValue = this.durationsOptions.some(
        (x) => x.id === this.model.duration?.id
      );
      if (!hasValue) this.model.duration = null;
      this.forceDurationRefresh();
    },
    // JSF: force the dropdown duration options to render (in the screen is not reflecting the computed changes)
    // the computed properties are working, but not refreshing in the screen
    forceDurationRefresh() {
      this.canShowDuration = false;
      this.$nextTick(() => {
        this.canShowDuration = true;
      });
    },
    async addServiceHandler() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.ShowToast('', 'Debe completar los campos requeridos.', 'error');
        return;
      }

      if (this.isRowAdded(this.model)) {
        this.ShowToast(
          '',
          'Ya existe la intervención registrada. (0373)',
          'error'
        );
        return;
      }
      this.interventions.push({
        analysisServiceCode: this.model.intervention?.id,
        analysisServiceDescription: this.model.intervention?.name,
        analysisServiceModalityCode: this.model.modality?.id,
        analysisServiceModalityDescription: this.model.modality?.name,
        durationCode: this.model.duration?.id,
        durationDescription: this.model.duration?.name,
        frequencyCode: this.model.frecuency?.id,
        frequencyDescription: this.model.frecuency?.name,
      });

      this.$refs.observer.reset();
      this.model = {
        intervention: null,
        frecuency: null,
        modality: null,
        duration: null,
      };

      this.$emit('on-change-therapies', this.interventions);
    },
    deleteServiceHandler(index) {
      this.interventions.splice(index, 1);
    },
    isRowAdded(model) {
      return (
        this.interventions.filter((x) => {
          return (
            model.intervention?.id === x.analysisServiceCode &&
            model.frecuency?.id === x.frequencyCode &&
            model.modality?.id === x.analysisServiceModalityCode &&
            model.duration?.id === x.durationCode
          );
        }).length > 0
      );
    },
    onChangeIntervention() {
      this.updateDurationOptions();
    },
    async get() {
      const { data } = await this.getAppointmentTherpies(this.id);
      this.interventions = data;
      if (data.length) this.$emit('on-change-therapies', data);
    },
  },
};
</script>
